import React, { JSX } from 'react';
import { Box } from '@chakra-ui/react';

type ProductsManagementPanelSectionProps = {
  children: React.ReactNode;
};

export const ProductsManagementPanelSection = ({ children }: ProductsManagementPanelSectionProps): JSX.Element => (
  <Box
    w={{ base: '100%', md: '50%' }}
    minW={{ base: 'auto', md: '500px' }}
    borderWidth="2px"
    borderRadius="4px"
    p={3}
    mb={1}
  >
    {children}
  </Box>
);
